<script>
import {IconArrowRightCircle} from "@tabler/icons-vue";

export default {
  name: "HistoryTimelineCard",
  components: {IconArrowRightCircle},
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: Number
  },
  methods: {
    formatFirmwareLabel(label) {
      if (!label) return null;
      const name = label.name ?? label.id;
      const version = label.version_number;
      return version ? `${name} (${version})` : `${name}`;
    },
    displayValue(key, value, which) {
      const labels = this.item?.properties?.attribute_labels?.[key];
      if (labels && (key === 'current_firmware_id' || key === 'target_firmware_id')) {
        const label = which === 'old' ? labels.from : labels.to;
        const formatted = this.formatFirmwareLabel(label);
        if (formatted) return formatted;
      }

      return value ?? 'NULL';
    },
  }
}
</script>

<template>
  <Card class="mt-3">
    <template #title>
      <span data-cy="item-description-display-history-card" class="capitalize">
        {{ item.description }}
      </span>
    </template>

    <template #subtitle>
      <div class="block -mt-3" data-cy="created-at-timeline">
        <small>{{ $dateService(item.created_at).format('lll') }}</small>
        <span class="mx-2 opacity-50">&centerdot;</span>
        <small>{{ $dateService(item.created_at).fromNow() }}</small>
      </div>
    </template>

    <template #content>
      <div class="-mt-3 text-xs leading-5 text-gray-500 flex-no-grow">
        <div v-if="item.event === 'rxswins_updated'">

          <div v-if="item.properties?.updated?.length">
            <p class="font-semibold">Updated</p>
            <div class="flex items-center gap-x-2 mb-2">
              <Tag v-for="rxSwin in item.properties.updated" severity="secondary" :value="rxSwin"/>
            </div>
          </div>

          <div v-if="item.properties?.attached?.length">
            <p class="font-semibold">Attached</p>
            <div class="flex items-center gap-x-2 mb-2">
              <Tag v-for="rxSwin in item.properties.attached" severity="secondary" :value="rxSwin"/>
            </div>
          </div>

          <div v-if="item.properties?.attached?.length">
            <p class="font-semibold" v-if="item.properties?.detached?.length">Detached</p>
            <div class="flex items-center gap-x-2 mb-2">
              <Tag v-for="rxSwin in item.properties.detached" severity="secondary" :value="rxSwin"/>
            </div>
          </div>
        </div>
        <div v-else-if="item.event === 'asset-device-added' || item.event === 'asset-device-removed'">
          <p class="font-semibold">
            {{ item.event === 'asset-device-added' ? 'Device added' : 'Device removed' }}
          </p>
          <div class="flex items-center gap-x-2 mb-2">
            <p>
              <strong>serial number: {{ item.properties?.device?.serial_number ?? ('#' + (item.properties?.device?.id ?? '')) }}</strong>
            </p>
          </div>
        </div>
        <div v-else v-for="(value, key) in item.properties.attributes"
             class="flex flex-col items-start gap-x-2"
             data-cy="item-description-value">
          <p class="font-semibold">
            {{ key }}
          </p>

          <div class="flex items-center gap-x-2 mb-2">
            <p v-if="item.properties.old">
              {{ displayValue(key, item.properties.old[key], 'old') }}
            </p>
            <p v-else>
              {{ displayValue(key, value, 'new') }}
            </p>

            <IconArrowRightCircle v-if="item.properties.old" :stroke-width="2" class="text-gray-400"/>
            <div>
              <p v-if="item.properties.old" class="text-ellipsis overflow-hidden">
                <strong>
                  {{ displayValue(key, value, 'new') }}
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="item.causer" #footer>
      <span class="text-surface-500">{{ $t('components.history_timeline_card.by_x', {name: item.causer.name}) }}</span>
    </template>
  </Card>
</template>

<style scoped>

</style>